import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const propertyAddonConfig = {
  /* ------------------------------- GET ----------------------------------- */

  getMasterAddons: {
    key: "getMasterAddons",
    url: "/api/v1/property-addons/master-addons",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getPropertyAddons: {
    key: "getPropertyAddons",
    url: "/api/v1/property-addons",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  /* ------------------------------- POST ---------------------------------- */

  addPropertyAddon: {
    key: "addPropertyAddon",
    url: "/api/v1/property-addons",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getPropertyAddons", "getMasterAddons"],
      onSuccessMessage: "Addon added to property successfully",
      onErrorMessage: "Failed to add addon to property",
    },
  },

  /* ------------------------------- PATCH --------------------------------- */

  updatePropertyAddon: {
    key: "updatePropertyAddon",
    url: (data) => `/api/v1/property-addons/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getPropertyAddons"],
      onSuccessMessage: "Property addon updated successfully",
      onErrorMessage: "Failed to update property addon",
    },
  },

  /* ------------------------------- DELETE --------------------------------- */

  removePropertyAddon: {
    key: "removePropertyAddon",
    url: (data) => `/api/v1/property-addons/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getPropertyAddons", "getMasterAddons"],
      onSuccessMessage: "Addon removed from property successfully",
      onErrorMessage: "Failed to remove addon from property",
    },
  },
};
